import { isObject } from "@videojs/utils/predicate";
//#region src/core/i18n/text.ts
/**
* Whether a value is a text descriptor: a translation key with its English default.
*
* @param value - Value to check.
* @public
*/
function isText(value) {
	return isObject(value) && "key" in value && "text" in value;
}
//#endregion
export { isText };
